/**
 * Центральная авторизация PikinLab — auth.pikinlab.ru.
 * Переопределяется через REACT_APP_CENTRAL_LOGIN_URL / REACT_APP_CENTRAL_LOGOUT_URL.
 */
const defaultCentralLogin = 'https://auth.pikinlab.ru/login';
const defaultCentralLogout = 'https://auth.pikinlab.ru/logout';

export function getCentralLoginUrl(): string {
  const url = process.env.REACT_APP_CENTRAL_LOGIN_URL;
  return (url && url.trim()) ? url.trim() : defaultCentralLogin;
}

export function getCentralLogoutUrl(): string {
  const url = process.env.REACT_APP_CENTRAL_LOGOUT_URL;
  return (url && url.trim()) ? url.trim() : defaultCentralLogout;
}

/**
 * URL для редиректа на центральный логин (auth.pikinlab.ru).
 * Параметр redirect — origin возврата (например test.pikinlab.ru).
 */
export function getCentralLoginRedirect(redirectUrl?: string): string {
  const base = getCentralLoginUrl();
  const redirect = redirectUrl ?? (typeof window !== 'undefined' ? window.location.origin : '');
  const separator = base.includes('?') ? '&' : '?';
  return redirect ? `${base}${separator}redirect=${encodeURIComponent(redirect)}` : base;
}
